import React from 'react';
import { motion } from 'framer-motion';
import { MicIcon, BrainCircuitIcon, TrendingUpIcon, NetworkIcon, GamepadIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function UseCasesSlide() {
  return <SlideLayout data-id="element-485">
      <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-486">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-487">
          Built for Production Workloads
        </h2>
        <p className="text-xl text-brand-text-dim" data-id="element-488">
          Latency-Sensitive & Cost-Sensitive
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-6 gap-6 max-w-5xl mx-auto" data-id="element-489">
        {/* Top Row - 3 Cards */}
        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-490">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-491" />
          <MicIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-492" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-493">
            Real-Time Voice & Chat
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-494">
            Sub-100ms time-to-first-token for natural conversational flow.
            Deterministic latency eliminates spikes that break interactions.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-495">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-496" />
          <BrainCircuitIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-497" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-498">
            Autonomous AI Agents
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-499">
            High call volume, tight cost budgets. Agents making thousands of
            calls need the lowest $/M tokens without sacrificing speed.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-500">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-501" />
          <TrendingUpIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-502" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-503">
            Financial Analytics
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-504">
            Speed and determinism matter. Low-jitter inference for real-time
            trend analysis where milliseconds translate to dollars.
          </p>
        </motion.div>

        {/* Bottom Row - 2 Cards Centered */}
        <motion.div variants={itemVariants} className="md:col-start-2 md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-505">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-506" />
          <NetworkIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-507" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-508">
            Multi-Agent Orchestration
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-509">
            Frameworks like AutoGen routing to cheaper open-source models.
            OpenFPGA makes them fast enough for tight loops.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-510">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-511" />
          <GamepadIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-512" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-513">
            Game AI & NPCs
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-514">
            Localized inference brains for complex NPC behavior. Low-latency,
            low-cost inference that runs alongside game logic.
          </p>
        </motion.div>
      </div>
    </SlideLayout>;
}